function getUserPhoneCheck(state) {
  return {
    phones: state.userPhoneCheck.phones,
    result: state.userPhoneCheck.result,
    isLoading: state.userPhoneCheck.loading,
    fetchError: state.userPhoneCheck.fetchUserPhoneCheckError,
    success: state.userPhoneCheck.success,
    isModifiable: state.userPhoneCheck.isModifiable,
    fetchErrorModifiable: state.userPhoneCheck.fetchUserPhoneCheckError,
    counter: state.userPhoneCheck.counter
  };
}

export { getUserPhoneCheck };
